import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import { useState, useEffect } from "react";
import axios from "axios";
export default function News() {
    const { t, i18n } = useTranslation();
    useScrollAnimation();

    const [dataNews, setDataNews] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const respons = await axios.get("https://laravel-api.alnujoud-jo.com/api/news");
                setDataNews(respons.data.data)
            }
            catch (error) {
                console.error("Error When Fetch Data : ", error)
            }
        }
        fetchData();
    }, [])

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    const showData = dataNews.map((el, index) =>
        <div key={index} className="f-col flex shadow-[0px_0px_10px_#00000029] rounded-[8px] gap-[30px]">
            <div className="w-100 w-[40%] h-[250px] border-r-[3px] border-r-[#017E89]">
                <img className="rounded-l-[8px] w-full h-full object-cover" src={el.image} alt="" />
            </div>
            <div className="w-100 w-[59%] p-[20px] flex flex-col justify-between gap-[15px]">
                <div className="flex flex-col gap-[15px]">
                    <div className="capitalize font-bold text-[20px]">
                        {t(getLocalizedText({ A: el.title_ar, E: el.title_en }))}
                    </div>
                    <p>
                        {t(getLocalizedText({ A: el.content_ar, E: el.content_en }).length > 50
                            ? getLocalizedText({ A: el.content_ar, E: el.content_en }).substring(0, 200) + "..."
                            : getLocalizedText({ A: el.content_ar, E: el.content_en }))}
                    </p>
                    <div className="flex items-center gap-[5px]">
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/calender.svg").default} alt="" />
                        <div className="font-bold text-[#017E89]">
                            {new Date(el.news_date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                        </div>
                    </div>
                </div>
                <Link to={`/newsDetails/${el.id}`}>
                    <span className="capitalize font-bold">{t("Read More")}</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("News & Events")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("News & Events")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-baseline gap-[7px]">
                        <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("News & Events")}</div>
                    </div>
                    <div className="flex flex-col gap-[20px]">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}